export const managementChangesMessages = {
  en: {
    snapshotSelection: {
      beforeLabel: 'First snapshot',
      afterLabel: 'Second snapshot',
      submitButtonTitle: 'Compare changes',
      snapshotNotReady:
        'Comparison can be performed only on two fully loaded snapshots.',
      notEnoughSnapshots: {
        placeholder: 'No snapshot available',
        title: 'Comparison is not currently available',
        description:
          'At least two saved snapshots are needed to use the comparison tool.',
      },
    },
    summary: {
      title: 'Summary of Changes',
      tabs: {
        devices: 'Devices',
        partNumbers: 'Part Numbers',
        managedIp: 'Managed IP',
        connectivityMatrix: 'Connectivity Matrix',
      },
    },
  },
};
